// extracted by mini-css-extract-plugin
export var banner = "_bt-0";
export var closeButton = "_bt-2";
export var greenCheckmark = "_bt-3";
export var hereLink = "_bt-4";
export var titleIcon = "_bt-1";